import { useEffect, ReactNode, useRef } from 'react';

import { useMeStore } from 'src/store/me/me.store';

import { useAuth } from '../hooks/use-auth';
import { useAuthStore } from '../store/auth.store';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
};

export default function AuthProvider({ children }: Props) {
  const { isAuthenticated } = useAuthStore();
  const { initializeAuth } = useAuth();
  const isInitialized = useRef(false);

  useEffect(() => {
    // Garantir que a inicialização ocorre apenas uma vez
    if (!isInitialized.current) {
      isInitialized.current = true;
      initializeAuth();
    }
  }, [initializeAuth]);

  // Sincronizar dados do usuário quando autenticado
  useEffect(() => {
    if (isAuthenticated) {
      const { me } = useMeStore.getState();
      // Só busca dados se ainda não tiver dados do usuário
      if (!me) {
        // getMyData();
      }
    }
  }, [isAuthenticated]);

  return <>{children}</>;
}
